import { render, staticRenderFns } from "./u-btn-arrow-outlined-tile.vue?vue&type=template&id=07036023&scoped=true&"
import script from "./u-btn-arrow-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07036023",
  null
  
)

export default component.exports